<ul>
  @for (item of items; track item) {
  <li>
    @if (item?.type === MenuItemType.Default) {
    <a [appNavigateToUrl]="item?.url">{{ item?.label }}</a>
    } @if (item?.type === MenuItemType.Large) {
    <a class="match-me" [appNavigateToUrl]="item?.url">
      <mat-icon svgIcon="gears"></mat-icon>
      <div>
        <h2>{{ item?.label }}</h2>
        <p>Find a great job fit</p>
      </div>
    </a>
    }
  </li>
  }
</ul>
